import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { initInformationState } from '../initialState'
import handleGetInfo from './informationAction'

const informationSlice = createSlice({
  name: 'information',
  initialState: initInformationState,
  reducers: {
    setInitInfo: (state, action: PayloadAction<any>) => {
      state.items = action.payload
    },
    setCollapseList: (state, action: PayloadAction<any>) => {
      state.collapseList = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(handleGetInfo.fulfilled, (state, action: PayloadAction<any>) => {
      if (!action.payload) return
      const { units, commodities, ports } = action.payload
      state.listData = {
        units,
        commodities,
        ports,
      }
    })
  },
})

export const informationCreateActions = informationSlice.actions
export default informationSlice
